// extracted by mini-css-extract-plugin
module.exports = {"header":"page-layout_header__a3A80","body":"page-layout_body__26a0J","footer":"page-layout_footer__3l5wF"};